import React from 'react';
// import logoImageReport from '../images/ProstatypeGenomics_logo_report.png';
import logoImageReport from '../images/Prostatype_logotype_CMYK.svg';


const ReportFooter = () => {
    return (
        <div className="report-footer">
            <div className="report-footer-line"></div>
            <div className="report-footer-content">
                <div className="report-footer-column">
                <div className="logo-and-address">

                    <img 
                        src={logoImageReport} 
                        alt="Logo" 
                        className="report-footer-logo" />
                    {/* <div className="report-footer-column"> */}
                    <div className="text-block">
                        <p>Prostatype Genomics Inc.</p>
                        <p>5 Mason Lane Suite 190</p>
                        <p>Irvine, CA 92618</p>
                    </div>
                </div>
                </div>
                <div className="report-footer-column">
                    <p>Phone: 949-681-6626</p>
                    <p>Test Information: <a href="http://www.prostatype.com">www.prostatype.com</a></p>
                </div>
                <div className="report-footer-column">
                    <p>© 2024 Prostatype Genomics, Inc.</p>
                    <p>All Rights Reserved.</p>
                </div>
            </div>
        </div>
    );
};

export default ReportFooter;
